var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"crly-a-common-btn-sign-up crly-icon",on:{"click":_vm.clickLoginBtn}},[_c('div',{staticClass:"crly-a-common-btn-sign-up__icon crly-icon"}),_c('span',{staticClass:"crly-a-common-btn-sign-up__label crly-icon-txt"})])
}
var staticRenderFns = []

export { render, staticRenderFns }